import { Dialog, DialogActions, DialogContent } from "@mui/material";
import { MprcDialogTitleClose, MprcReorderList, MprcRequestErrorDialog, MprcRequestIndicator, MprcSpinnerIndicator, ReorderListItem } from "components";
import { ButtonCancel, ButtonSave } from "components/buttons";
import { useCoreApi } from "providers/CoreApiProvider";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

////////////////////////////////////////////////////////////////////////////////

interface IPros {
    title?: string;
    masterPublicationId: string;
    onClose: (changed: boolean) => void;
}

/////////////////////////////////////////////////////////////////////////////////

export const ThreadPublicationsreOrderDialog = (props: IPros) => {
    const { masterPublicationId, title, onClose } = props;
    const [newOrder, setNewOrder] = useState<ReorderListItem[] | undefined>(undefined);
    const [items, setItems] = useState<ReorderListItem[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [saving, setSaving] = useState<boolean>(false);
    const [lastError, setLastError] = useState<any>(null);
    const api = useCoreApi();
    const { t } = useTranslation("knowledge");

    ///
    useEffect(() => {
        async function load() {
            try {
                const result = await api.v1.knowledgePublication.getPublicationThreadSequence({ masterPublicationId });
                setItems(result.data.map(p => ({ id: p.publicationId, text: p.title })));
            }
            catch {
            }
            finally {
                setLoading(false);
            }

            setLoading(false);
        }
        if (loading) load();

    }, [loading]);

    ///
    useEffect(() => {
        async function save() {
            try {
                const result = await api.v1.knowledgePublication.threadReorder({
                    masterPublicationId,
                    orderedItems: newOrder!.map((p) => p.id)
                });

                onClose(result.data);
            }
            catch (e) {
                setLastError(e);
            }
            finally {
                setSaving(false);
            }
        }

        if (saving) save();
    }, [saving]);

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////
    return (
        <Dialog
            open
            onClose={() => onClose(false)}
        >
            <MprcDialogTitleClose
                title={t("Feed.Card.Actions.ThreadPublicationsreOrderDialog.Title")}
                subtitle={title}
                onClose={() => onClose(false)}
            />

            <DialogContent>
                <MprcRequestErrorDialog error={lastError} onClose={() => setLastError(null)} />

                <MprcRequestIndicator type="post" visible={saving} />

                {
                    loading
                        ? <MprcSpinnerIndicator />
                        : <MprcReorderList items={items} onChangeOrder={(items) => setNewOrder(items)} />
                }
            </DialogContent>

            <DialogActions>
                <ButtonCancel onClick={() => props.onClose(false)} />
                <ButtonSave disabled={newOrder == undefined} onClick={() => setSaving(true)} />
            </DialogActions>
        </Dialog>
    );
};
